var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"no_data"}},[_c('div',{staticClass:"no_data"},[_c('img',{attrs:{"src":_vm.noData[_vm.noIndex].img,"alt":""}}),_vm._v(" "+_vm._s(_vm.noData[_vm.noIndex].content)+" "),(_vm.noData[_vm.noIndex].btn)?_c('div',{staticClass:"no_data1",on:{"click":_vm.toCreate}},[_vm._v(" "+_vm._s(_vm.noData[_vm.noIndex].btn))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }